<div class="d-flex align-items-center justify-content-between mb-5">
    <h1 class="montserrat-light text-gray-500 text-capitalize">{{ title }}</h1>
    <div class="d-flex align-items-center">
        <a href="javascript:;" class="search rounded-circle bg-gray-500 mr-3">
            <img src="./assets/images/search.svg" alt="Search" title="Search" />
        </a>
        <a
            href="javascript:;"
            class="new-campaign bg-gray-500 px-5 py-3"
            [routerLink]="['/campaign']"
        >
            <img
                src="./assets/images/icons/nav/new-campaign-active.svg"
                alt="New campaign"
                title="New campaign"
                class="mr-2"
            />
            New campaign
        </a>
    </div>
</div>
<div class="my-profile-bar position-relative text-center mx-auto">
    <ul class="p-0 m-0 d-flex align-items-center justify-content-between">
        <li>
            <button
                (click)="navigateToUrl('my-profile')"
                [ngClass]="{
                    selected: checkIfLinkActive('my-profile')
                }"
                class="text-capitalize"
            >
                my profile
            </button>
        </li>
        <hr class="vertial-separator bg-gray-500 mx-4" />
        <li>
            <button
                (click)="navigateToUrl('payment-methods')"
                [ngClass]="{
                    selected: checkIfLinkActive('payment-methods')
                }"
                class="text-capitalize"
            >
                payment methods
            </button>
        </li>
        <hr class="vertial-separator bg-gray-500 mx-4" />
        <li>
            <button
                (click)="navigateToUrl('my-wallet')"
                [ngClass]="{
                    selected: checkIfLinkActive('my-wallet')
                }"
                class="text-capitalize"
            >
                my wallet
            </button>
        </li>
        <hr class="vertial-separator bg-gray-500 mx-4" />
        <li>
            <button
                (click)="navigateToUrl('transactions-history')"
                [ngClass]="{
                    selected: checkIfLinkActive('transactions-history')
                }"
                class="text-capitalize"
            >
                transactions history
            </button>
        </li>
    </ul>
</div>
